import {
  Avatar,
  Box,
  Stack,
  Text,
  VStack,
  Link,
} from "@chakra-ui/react";
import React from "react";
import img from "../Components/bgImage/logo1.jpg";

const Footer = () => {
  return (
    <Box
      bg={"blackAlpha.900"}
      color={"whiteAlpha.700"}
      minH={"48"}
      px={"16"}
      py={["16", "8"]} // 16 in phone otherwise 8
    >
      <Stack
        direction={["column", "row"]} //column in phone otherwise row
        h={"full"}
        alignItems={"center"}
      >
        <VStack w={"full"} alignItems={["center", "flex-start"]}>
          <Text fontWeight={"bold"} fontSize={"md"}>About App</Text>
          <Text
            fontSize={"sm"}
            letterSpacing={"widest"}
            textAlign={["center", "left"]}
          >
            With CryptoPedia, you can easily access the latest market data,
            including coin prices, market capitalization, trading volumes, and
            more.
          </Text>
        </VStack>
        <VStack>
          <Avatar boxSize={"20"} mt={["4", "0"]} src={img} />
            <Text textAlign={"center"} w={"150px"}>
            <Link href="https://www.linkedin.com/in/muazim-maqbool/" isExternal>
              Contact Founder
            </Link>
            </Text>
          
        </VStack>
      </Stack>
    </Box>
  );
};

export default Footer;
